import React from 'react';
import { timeZoneSelector } from 'Features/App/appSlice';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { WidgetWrapper } from 'Utils/Widgets/WidgetWrapper';
import { commonWidgetInfo, sourceIdSetter } from '../utils';
import { WidgetData } from '../types';

type WidgetCardProps = {
  widgetData: WidgetData
  widgetLayout: () => JSX.Element
  hasWebsocket?: boolean
  isCommon?: boolean
  hasTimeout?: boolean
}

function WidgetCardDefault({
  widgetData,
  widgetLayout,
  hasWebsocket = false,
  isCommon = false,
  hasTimeout = false,
}: WidgetCardProps) {
  const zones = useSelector(timeZoneSelector, (a, b) => a.selectedUserTimeZone === b.selectedUserTimeZone);
  const { datasourceId } = useParams();

  const object = React.useMemo(() => ({
    ...commonWidgetInfo(zones.selectedUserTimeZone),
    requestItems: widgetData.map(sourceIdSetter(parseInt(datasourceId, 10))),
  }), [zones.selectedUserTimeZone, widgetData, datasourceId]);

  return (
    <WidgetWrapper
      object={object}
      Widget={widgetLayout}
      hasTimeout={hasTimeout}
      hasWebsocket={hasWebsocket}
      isCommon={isCommon}
    />
  );
}

export const WidgetCard = React.memo(WidgetCardDefault);
WidgetCard.displayName = 'WidgetCard';
